import type { ThemingConfig } from '@chakra-ui/react';

import type { ExcludeUndefined } from 'types/utils';

import config from 'configs/app';

export const BODY_TYPEFACE = config.UI.fonts.body?.name ?? 'Inter, InterFallback';
export const HEADING_TYPEFACE = config.UI.fonts.heading?.name ?? 'Poppins';

export const fonts: ExcludeUndefined<ThemingConfig['tokens']>['fonts'] = {
  heading: { value: `${ HEADING_TYPEFACE }, sans-serif` },
  body: { value: `${ BODY_TYPEFACE }, sans-serif` },
};

export const textStyles: ThemingConfig['textStyles'] = {

  /**
   * Typography scale (xl/lg/md/sm/xs).
   *
   * Source of truth: `docs/BBVISION_THEME.md` (Text styles section).
   *
   * Mapping:
   * - xl: H1 (responsive: mobile -> desktop)
   * - lg: Section title
   * - md: Body
   * - sm: CTA / link
   * - xs: Label
   */
  xl: {
    value: {
      fontSize: { base: '24px', md: '30px' },
      lineHeight: { base: '32px', md: '36px' },
      fontWeight: '600',
      fontFamily: 'heading',
    },
  },
  lg: {
    value: {
      fontSize: '16px',
      lineHeight: '20px',
      fontWeight: '500',
      fontFamily: 'heading',
    },
  },
  md: {
    value: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '500',
      fontFamily: 'body',
    },
  },
  sm: {
    value: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '500',
      fontFamily: 'body',
    },
  },
  xs: {
    value: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '500',
      fontFamily: 'body',
    },
  },

  /**
   * Backward-compatible grouped styles.
   * Keep existing `textStyle="heading.*"` / `textStyle="text.*"` usages working.
   */
  heading: {
    xl: { value: { fontSize: { base: '24px', md: '30px' }, lineHeight: { base: '32px', md: '36px' }, fontWeight: '600', fontFamily: 'heading' } },
    lg: { value: { fontSize: '16px', lineHeight: '20px', fontWeight: '500', fontFamily: 'heading' } },
    md: { value: { fontSize: '16px', lineHeight: '24px', fontWeight: '500', fontFamily: 'heading' } },
    sm: { value: { fontSize: '14px', lineHeight: '20px', fontWeight: '500', fontFamily: 'heading' } },
    xs: { value: { fontSize: '12px', lineHeight: '16px', fontWeight: '500', fontFamily: 'heading' } },
  },
  text: {
    xl: { value: { fontSize: '16px', lineHeight: '24px', fontWeight: '500', fontFamily: 'body' } },
    md: { value: { fontSize: '16px', lineHeight: '24px', fontWeight: '500', fontFamily: 'body' } },
    sm: { value: { fontSize: '14px', lineHeight: '20px', fontWeight: '500', fontFamily: 'body' } },
    xs: { value: { fontSize: '12px', lineHeight: '16px', fontWeight: '500', fontFamily: 'body' } },
  },
};
